import React, { useState, useContext, useEffect } from "react";
import { AppContext } from "../../context/AppContext";
import optionIcon from "../../assets/images/bx_edit.svg";
import "../../assets/css/myAttendence.scss";
import ReactPaginate from "react-paginate";
import Modal from "react-bootstrap/Modal";
import { PostCallWithErrorResponse, simpleGetCallWithErrorResponse } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { ToastMsg } from "../TostMsg";
import Loader from "../Loader";
import disabled_edit from "../../assets/images/disabled_edit.svg";
import {
  convertTimeIn24Format,
  getDDateddmmyyyy,
  displayTime,
} from "../../common";

import moment from "moment";
// import Year from "react-datepicker/dist/year";

const EmployeeAttendence = () => {
  const { sidebar, setSidebar, Dark, setDark, userData, permissions } =
    useContext(AppContext);

  const [editRecord, setEditRecord] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose = () => setEditRecord(false);
  const [empolyeList, setEmpolyeList] = useState([]);
  console.log("empolyeList,", empolyeList);
  const [empoleName, setEmpoleName] = useState([]);
  const [emplyId, serEmplyId] = useState(Number(userData.EmpId));
  const [yearsFromJoining, setYearsFromJoining] = useState([]);
  const [loading, setLoading] = useState(false);
  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedPunchData, setExpandedPunchData] = useState([]);
  const toggleRow = (index, punchBreakdown) => {
    if (expandedRow === index) {
      setExpandedRow(null);
      setExpandedPunchData([]);
    } else {
      setExpandedRow(index);
      setExpandedPunchData(punchBreakdown || []);
    }
  };

  var d = new Date();
  let mon = d.getMonth() + 1;
  const [employeeListObj, setEmployeeListObj] = useState({
    EmployeeId: Number(userData.EmpId),
    OrgId: Number(userData.OrgId),
    Month: mon,
  ExportToExcel: false,
    Year: new Date().getFullYear(),
  });
  const [editObj, setEditObj] = useState({
    Id: 1,
    EmpId: Number(userData.EmpId),
    OrgId: Number(userData.OrgId),
  });
  const [updatePayloadData, setupdatePayloadData] = useState({
    Id: 0,
    OrgId: Number(userData.OrgId),
    Intime: "",
    OutTime: "",
    Date: "",
    InPlatform: 1,
    OutPlatform: 1
  });
  const [isLoading, setIsLoading] = useState(false);
  const minOffset = 0;
  const maxOffset = 1;
  let crryear = new Date().getFullYear();
  let allYears = [];
  for (let x = 0; x <= maxOffset; x++) {
    allYears.push(crryear - x);
  }
  useEffect(() => {
    getEmpolylistApi();
  }, [employeeListObj]);

  useEffect(() => {

    getYearFromJoining()

  }, [emplyId]);



  const getEmpolylistApi = () => {
    setLoading(false);
    if (employeeListObj.Month >= 1 && employeeListObj.Year >= 1) {
      setLoading(true);

      PostCallWithErrorResponse(
        ApiConfig.NewEMPLOYEE_LIST,
        JSON.stringify(employeeListObj)
      )
        .then((res) => {
          setLoading(false);
          setEmpolyeList(
            res.json?.Data.Attendance ? res.json?.Data.Attendance : []
          );

        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const getYearFromJoining = () => {

    simpleGetCallWithErrorResponse(ApiConfig.GET_YEARS_FROM_JOINING + emplyId).then((res) => {
      if (res?.json?.Success) {
        setYearsFromJoining(
          res?.json?.Data
        )
      }
    })

  }

  useEffect(() => {
    PostCallWithErrorResponse(
      ApiConfig.EMPLOEE_NAME_LIST,
      JSON.stringify({ OrgId: Number(userData.OrgId) })
    )
      .then((res) => {
        console.log(res);
        setEmpoleName(res.json?.Data ? res.json?.Data : []);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const getTimeApi = (id, date) => {
    console.log("id,", id);
    console.log("date,", getDDateddmmyyyy(date));
    const body = {
      AttenId: id,
      EmpId: emplyId,
      OrgId: Number(userData.OrgId),
    };
    PostCallWithErrorResponse(ApiConfig.GETINOUT_TIME, JSON.stringify(body))
      .then((res) => {
        var inTimeIn24Format =
          res.json.Data[0]?.InTime &&
          moment(res.json.Data[0]?.InTime, "hh:mm A").format("HH:mm");
        var outTimeIn24Format =
          res.json.Data[0]?.OutTime &&
          moment(res.json.Data[0]?.OutTime, "hh:mm A").format("HH:mm");
        // if (res.json.Data.length !== 0) {
        setupdatePayloadData({
          ...updatePayloadData,
          EmpId: res.json.Data[0]?.EmployeeId
            ? res.json.Data[0]?.EmployeeId
            : emplyId,
          Id: res.json.Data[0]?.Id ? res.json.Data[0]?.Id : 0,
          Intime: inTimeIn24Format ? inTimeIn24Format : "",
          OutTime: outTimeIn24Format ? outTimeIn24Format : "",
          Date: getDDateddmmyyyy(date),
        });
        // }
        setEditObj({
          ...editObj,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const UpdateTimeApi = () => {
    setIsLoading(true);
    PostCallWithErrorResponse(
      ApiConfig.UPDATE_TIME,
      JSON.stringify(updatePayloadData)
    )
      .then((res) => {
        if (res.json && res.json?.Success === true) {
          ToastMsg("success", res.json.Message);
          setIsLoading(false);
          handleClose(false);
        } else {
          ToastMsg("error", res.json.Message);
          setIsLoading(false);
        }
        getEmpolylistApi(emplyId);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const convertTime12to24forPunchOutTime = (time12h) => {
    const [time, modifier] = time12h.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    } else {
      hours = parseInt(hours, 10);
    }
    return `${hours < 10 ? 0 : ""}${hours}:${minutes}`;
  };

  // let permissions = userData.Permissions;
  let splitPermissionsArray = permissions;

  var now = new Date();
  var datetime = now.toLocaleTimeString();

  const hasEditPermission = permissions && permissions["Edit Subordinates Attendance"];
  const totalCols = hasEditPermission ? 9 : 8;

  return (
    <>
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div className="role-content-main">
          <div className="sub-header-role mb-4">
            <h6 className="mt-2">Subordinates Attendance</h6>
          </div>
          <div className="d-flex mainHeader2 custom-mb">
            <div className="role-table-header-main">
              <div className="search-input-wrapper-main">
                <select
                  className="form-select input-select-option"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setEmployeeListObj({
                      ...employeeListObj,
                      EmployeeId: Number(e.target.value),
                    });
                    serEmplyId(Number(e.target.value));
                  }}
                  value={employeeListObj.EmployeeId}
                >
                  <option value="">Select Employee Name</option>
                  {empoleName &&
                    empoleName.map((emp) => {
                      return <option value={emp.Id}>{emp.FullName}</option>;
                    })}
                </select>
              </div>
              <div className="search-input-wrapper-main mx-4">
                <select
                  className="form-select input-select-option"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setEmployeeListObj({
                      ...employeeListObj,
                      Year: Number(e.target.value),
                    });
                  }}
                  value={employeeListObj.Year}
                >
                  {/* <option value="">Select Year</option> */}
                  {yearsFromJoining.map((year, i) => {
                    return (
                      <option key={i} value={year?.year}>
                        {year?.year}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="search-input-wrapper-main">
                <select
                  className="form-select input-select-option"
                  aria-label="Default select example"
                  onChange={(e) => {
                    setEmployeeListObj({
                      ...employeeListObj,
                      Month: Number(e.target.value),
                    });
                  }}
                  value={employeeListObj.Month}
                >
                  {/* <option value="">Select Month</option> */}
                  <option value="1">Janaury</option>
                  <option value="2">February</option>
                  <option value="3">March</option>
                  <option value="4">April</option>
                  <option value="5">May</option>
                  <option value="6">June</option>
                  <option value="7">July</option>
                  <option value="8">August</option>
                  <option value="9">September</option>
                  <option value="10">October</option>
                  <option value="11">November</option>
                  <option value="12">December</option>
                </select>
              </div>
            </div>
            {/* <div className="entries-wrapper-main ">
              <p>Entries per page</p>
              <select
                className="form-select select-drop"
                aria-label="Default select example"
              >
                <option selected>10</option>
                <option value="1">20</option>
                <option value="2">10</option>
                <option value="3">5</option>
              </select>
            </div> */}
          </div>
          {/* <div className='emptyPage'>
                        <img src={emptypage} alt="" />
                    </div> */}
          <div className="table-wrapper-main mb-4">
            {loading ? (
              <Loader />
            ) : (
              <table>
                <thead>
                  <tr className="firstTabelRow">
                    <th style={{ width: '40px' }}></th>
                    {/* <th>Sr. No</th> */}
                    <th>Date</th>
                    <th>Shift Timing</th>
                    <th>Check In</th>
                    <th>Check Out</th>
                    <th>Total Hours</th>
                    <th>Remarks</th>
                    {/* {splitPermissionsArray && splitPermissionsArray["Edit Employee Attendance"] && } */}

                    {hasEditPermission && <th>Actions</th>}
                  </tr>
                </thead>
                <tbody>
                  {empolyeList && empolyeList.length > 0 ? (
                    empolyeList.map((empoly, index) => {
                      return (
                        <React.Fragment key={index + "empoly"}>
                          <tr className="table-row-main">
                            <td
                              style={{ cursor: 'pointer', textAlign: 'center', color: '#53B7E8' }}
                              onClick={() => toggleRow(index, empoly.PunchBreakdown)}
                            >
                              {expandedRow === index ? '▲' : '▼'}
                            </td>
                            <td>{empoly.DateString}</td>
                            <td>{empoly.ShiftTiming}</td>
                            <td>{empoly.CheckIn}</td>
                            <td>{empoly.CheckOut}</td>
                            <td>
                              <span>{empoly.TotalHours}</span>
                              <span
                                style={{
                                  cursor: 'pointer',
                                  backgroundColor: '#EEF8FD',
                                  border: '1px solid #53B7E8',
                                  borderRadius: '12px',
                                  padding: '2px 8px',
                                  fontSize: '10px',
                                  color: '#53B7E8',
                                  marginLeft: '8px',
                                  fontWeight: 500,
                                  display: 'inline-block',
                                }}
                                onClick={(e) => { e.stopPropagation(); toggleRow(index, empoly.PunchBreakdown); }}
                              >
                                {empoly.PunchBreakdown?.length > 0
                                  ? `${empoly.PunchBreakdown.length} Sessions`
                                  : 'Sessions'}
                              </span>
                            </td>

                            <td
                              className={
                                empoly.Remarks === "Absent"
                                  ? "status-label-danger"
                                  : empoly.Remarks === "Present" ||
                                    empoly.Remarks === "Present Day"
                                    ? "status-label-green"
                                    : empoly.Remarks === "Weekend" ||
                                      empoly.Remarks === "Off Day"
                                      ? "status-grey"
                                      : empoly.Remarks?.includes("Leave") ||
                                        empoly.Remarks?.includes("Holiday")
                                        ? "status-h-leave"
                                        : empoly.Remarks === "Late punch In" ||
                                          empoly.Remarks === "Early punch Out" ||
                                          empoly.Remarks === "Miss punch" ||
                                          empoly.Remarks === "Miss punch Out"
                                          ? "status-label-warning"
                                          : "status-label-grey"
                              }
                            >
                              {empoly.Remarks}
                            </td>



                            {/* {splitPermissionsArray && splitPermissionsArray.includes("Edit Employee Attendance") && (

                          )} */}

                            {hasEditPermission && (
                              <td>
                                <img
                                  src={optionIcon}
                                  alt=""
                                  className="pointer"
                                  onClick={() => {
                                    const firstPunch = empoly.PunchBreakdown?.[0];
                                    const inTime24 = firstPunch?.PunchIn ? moment(firstPunch.PunchIn, "hh:mm A").format("HH:mm") : "";
                                    const outTime24 = firstPunch?.PunchOut ? moment(firstPunch.PunchOut, "hh:mm A").format("HH:mm") : "";
                                    setupdatePayloadData({
                                      Id: firstPunch?.Id || 0,
                                      EmpId: Number(employeeListObj.EmployeeId),
                                      OrgId: Number(userData.OrgId),
                                      Intime: inTime24,
                                      OutTime: outTime24,
                                      Date: empoly.DateString,
                                      InPlatform: 1,
                                      OutPlatform: 1,
                                    });
                                    setEditRecord(true);
                                  }}
                                />


                                {/* {empoly.Remark === "Present" ? (
                                <img
                                  src={optionIcon}
                                  alt=""
                                  className="pointer"
                                  onClick={() => {
                                    setEditRecord(true);
                                    getTimeApi(empoly.Id, empoly.InTime);
                                    setIds(empoly.Id);
                                    setupdatePayloadData({
                                      Id: 0,
                                      EmpId: Number(userData.EmpId),
                                      OrgId: Number(userData.OrgId),
                                      Intime: "",
                                      OutTime: "",
                                      Date: ""
                                    });
                                  }}
                                />
                              ) : (
                                <img
                                  src={disabled_edit}
                                  alt=""
                                  className="me-3"
                                />
                              )} */}
                              </td>
                            )}
                          </tr>
                          {expandedRow === index && (
                            <tr>
                              <td colSpan={totalCols} style={{ padding: '0 16px 12px 48px', backgroundColor: 'transparent' }}>
                                <div style={{
                                  backgroundColor: '#fff',
                                  borderRadius: '10px',
                                  padding: '14px 18px',
                                  boxShadow: '0 2px 8px rgba(83,183,232,0.08)',
                                  border: '1px solid #ddeaf3',
                                }}>
                                  <div style={{ color: '#53B7E8', fontWeight: 700, fontSize: '13px', marginBottom: '12px', letterSpacing: '0.3px' }}>
                                    Punch Breakdown
                                  </div>
                                    <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 6px' }}>
                                      <thead>
                                        <tr>
                                          {['Session', 'Punch In', 'Punch Out', 'Session Hours', 'Action'].map((h, i) => (
                                            <th key={i} style={{
                                              backgroundColor: '#EEF8FD',
                                              color: '#333',
                                              fontSize: '11px',
                                              fontWeight: 600,
                                              padding: '8px 14px',
                                              textAlign: 'left',
                                              borderRadius: i === 0 ? '8px 0 0 8px' : i === 4 ? '0 8px 8px 0' : '0',
                                            }}>{h}</th>
                                          ))}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {expandedPunchData && expandedPunchData.length > 0 ? (
                                          expandedPunchData.map((punch, i) => (
                                            <tr key={i}>
                                              <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444', fontWeight: 500 }}>{punch.Session || '-'}</td>
                                              <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{punch.PunchIn || '-'}</td>
                                              <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{punch.PunchOut || '-'}</td>
                                              <td style={{ padding: '7px 14px', fontSize: '12px', color: '#444' }}>{punch.SessionHours || '-'}</td>
                                              <td style={{ padding: '7px 14px', fontSize: '12px' }}>
                                                {hasEditPermission && (
                                                  <img
                                                    src={optionIcon}
                                                    alt="edit"
                                                    style={{ width: '16px', height: '16px', cursor: 'pointer' }}
                                                    onClick={() => {
                                                      const inTime24 = punch.PunchIn ? moment(punch.PunchIn, "hh:mm A").format("HH:mm") : "";
                                                      const outTime24 = punch.PunchOut ? moment(punch.PunchOut, "hh:mm A").format("HH:mm") : "";
                                                      setupdatePayloadData({
                                                        Id: punch.Id || 0,
                                                        EmpId: Number(employeeListObj.EmployeeId),
                                                        OrgId: Number(userData.OrgId),
                                                        Intime: inTime24,
                                                        OutTime: outTime24,
                                                        Date: empoly.DateString,
                                                        InPlatform: 1,
                                                        OutPlatform: 1,
                                                      });
                                                      setEditRecord(true);
                                                    }}
                                                  />
                                                )}
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td colSpan={5} style={{ padding: '10px 14px', fontSize: '12px', color: '#828282', textAlign: 'center' }}>
                                              No punch records found
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                </div>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })
                  ) : (
                    <tr className="ErrorDataNotFound">
                      <td colSpan={totalCols}>Data Not Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>

      {/* Modal For Edit */}
      <Modal
        Modal
        size="md"
        show={editRecord}
        onHide={() => setEditRecord(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Record</Modal.Title>
        </Modal.Header>
        <div className="lineSeperate"></div>
        <Modal.Body>
          <div className="editModalBody">
            <div className="d-flex align-items-center diffbtns">
              <div className="mx-2">
                <label>In Time</label>
              </div>
              <div>
                <input
                  value={
                    updatePayloadData?.Intime
                      ? convertTime12to24forPunchOutTime(
                        updatePayloadData?.Intime
                      )
                      : "00:00"
                  }
                  type="time"
                  onChange={(e) => {
                    setupdatePayloadData({
                      ...updatePayloadData,
                      Intime: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="d-flex align-items-center diffbtns">
              <div className="mx-2">
                <label>Out Time</label>
              </div>
              <div>
                <input
                  value={
                    updatePayloadData?.OutTime
                      ? convertTime12to24forPunchOutTime(
                        updatePayloadData?.OutTime
                      )
                      : "00:00"
                  }
                  type="time"
                  onChange={(e) => {
                    setupdatePayloadData({
                      ...updatePayloadData,
                      OutTime: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className="lineSeperate"></div>
        <div className="d-flex justify-content-end align-items-center mainBtnsSub">
          <button className="btn-width cancelBtn mx-3" onClick={handleClose}>
            Cancel
          </button>

          <button
            className="btn-width saveBtn"
            onClick={UpdateTimeApi}
            disabled={isLoading ? true : false}
          >
            {isLoading ? (
              <div
                className="spinner-border mx-auto mt-2"
                style={{
                  width: "1.5rem",
                  height: "1.5rem",
                }}
              />
            ) : (
              "Save"
            )}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default EmployeeAttendence;
